import { useTheme } from "styled-components";
import { NAMESPACE } from "@m/alchemy-theme";
import { createContext, useContext, useMemo } from "react";
export const GridContext = createContext(undefined);
export const useGridContext = (breakpointsFromProps = {}) => {
    const breakpointsFromContext = useContext(GridContext);
    return useMemo(() => ({ ...breakpointsFromContext, ...breakpointsFromProps }), [breakpointsFromContext, breakpointsFromProps]);
};
const EMPTY = {};
export const useBreakpoints = (breakpointsFromProps = EMPTY) => {
    const theme = useTheme();
    const themeBreakpoints = theme[NAMESPACE].breakpoints;
    const breakpointsFromContext = useMemo(() => ({ ...themeBreakpoints, ...breakpointsFromProps }), [themeBreakpoints, breakpointsFromProps]);
    return breakpointsFromContext;
};
